import * as React from 'react';
import { css } from 'styled-components';
import {
  mediaQueries,
  setFontFormat,
  titleWeight,
  setFontSizeByModule,
} from 'src/components/common/theme/component-styles';
import Layout from 'src/components/common/theme/Layout';
import { ModuleProps } from 'src/utils/module-util';
import { checkValue, quoteAlterations } from 'src/components/common/helper';

import { Typo } from 'src/components/common/ui';
import { UitkFigure, UitkImage } from 'uitk-react-images';
import { useWindowDimensions } from 'src/components/common/useWindowDimentions';

const CpCmsLiteContentV3 = (props: ModuleProps) => {
  const {
    defaultSetting: { style },
    data: {
      description: paragraphDesktop,
      descriptionCopySizeDesktop,
      descriptionCopySizeMobile,
      descriptionCopyWeight,
      headline,
      subHeadline,
      module,
      moduleCopyColor,
      showModuleDivider,
      moduleStyle = 'text-left',
      logoImage,
      headlineColor,
      paragraphColor="",
      backgroundColor="",
      increaseLogoSize="",
      paragraphMobile = ""
    },
    id
  } = props;
  
  const isModuleSeparator = checkValue(showModuleDivider) && showModuleDivider === 'True' ? true : false;
  const { width: windowWidth } = useWindowDimensions();
  const description = windowWidth < 768 && checkValue(paragraphMobile) ? paragraphMobile : paragraphDesktop;
  const moduleCss = () => {
  
    const descriptionCopySizeDesktopMap = setFontSizeByModule(
      module,
      'descriptionCopySizeDesktop',
      descriptionCopySizeDesktop
    );

    const descriptionCopySizeMobileMap = setFontSizeByModule(
      module,
      'descriptionCopySizeMobile',
      descriptionCopySizeMobile
    );
    const getModuleCopyColor = checkValue(moduleCopyColor) ? moduleCopyColor : '';
    const getModuleSeparatorColor = checkValue(style.moduleDividerColor) ? style.moduleDividerColor : '';

    return `  
       
      ${checkValue(headlineColor) ? `.content_v3 h2.cms-typo{ color:${headlineColor} !important;}` : ``}

      ${style?.bodyFont === "Reckless Neue" ? `
      @media only screen and (min-width: 1025px) {
        .content_v3 h2.cms-typo {
          font-size:56px !important;
          line-height:115% !important;
        }
      }
      .content_v3 h2.cms-typo {
        font-weight:300 !important;
      }
      ` : ``}
                                    
              ${setFontFormat(
      '.content_v3 p.cms-typo',
      descriptionCopySizeDesktopMap,
      titleWeight(descriptionCopyWeight),
      getModuleCopyColor
    )}            
              .content_v3-module {
                .intro-module-seperator{
                  ${isModuleSeparator
        ? getModuleSeparatorColor !== ''
          ? `background: ${getModuleSeparatorColor} !important;`
          : ''
        : `display: none !important;`
      },
                }                   
              };       
              @media only screen and (max-width: ${mediaQueries.tab}) {                                            
                ${setFontFormat(
        '.content_v3 p.cms-typo',
        descriptionCopySizeMobileMap,
        titleWeight(descriptionCopyWeight),
        getModuleCopyColor
      )}              
              } 

            ${checkValue(paragraphColor) ? `
            &.content-section{
              .content_v3-module p {
                color:${paragraphColor} !important;
              }
            }
          ` : ""}  

          ${checkValue(backgroundColor) ? `
          &.content-section{
            .content_v3,
            .content_v3 .container {
              background-color:${backgroundColor} !important;
            }
          }
        ` : ""} 
        ${checkValue(increaseLogoSize) ? `
        .content_v3-module--logo{
          max-width: calc(204px*${increaseLogoSize});
          max-height: calc(160px*${increaseLogoSize});
        }
        .content_v3-module--mobile-logo{
          max-width: calc(200px*${increaseLogoSize});
          max-height: calc(64px*${increaseLogoSize});
        }` 
        : ""}
            `;
  };

  const headLineWithQoute = quoteAlterations.makeQuoteText(headline);

  const mainContent = () => (
    <>
      {checkValue(subHeadline) && <Typo.HTMLText tag="h4" exClass={`${logoImage.length == 0 ? 'content_v3-module--full-width-sub-title' : ''} override-subheading-font-family`}>{subHeadline}</Typo.HTMLText>}
      {checkValue(description) && <p className={`${logoImage.length == 0 ? 'content_v3-module--full-width' : ''}`} dangerouslySetInnerHTML={{ __html: description }}></p>}
    </>
  )

  return (
    <>
      {checkValue(headline) || checkValue(description) ? (
        <Layout
          HtmlTag="section"
          className="content-section"
          css={css`
            ${moduleCss()}
          `}
          id={id}         
        >
          <div className="content_v3 content_v3-webflow">
            <div className="container">
            {/* descktop image  */}
            {logoImage.length > 0 && (
              <div className="logo-wrapper">
                <UitkFigure className='content_v3-module--logo'>
                  <UitkImage alt='Logo' src={logoImage[0].url} lazyLoading="lazy" />
                </UitkFigure>
              </div>
            )}

            {/* <div className={`container`}> */}
              <div
                className={`content_v3-module content_v3-module--${checkValue(moduleStyle) ? moduleStyle.toLowerCase() : `text-left`
                  } ${!isModuleSeparator ? `noseperator` : ``}`}
              >
                {logoImage.length > 0 && (
                  <div className="logo-wrapper">
                      <img alt="Logo" className="content_v3-module--mobile-logo uitk-image-media" src={logoImage[0].url} loading="lazy" />
                  </div>
                )}

                {checkValue(headline) && <Typo.HTMLText tag="h2" exClass='override-heading-font-family'>{quoteAlterations.isQuotesAvailable(headLineWithQoute) ? quoteAlterations.addQuotes(headLineWithQoute) : headLineWithQoute}</Typo.HTMLText>}
                { moduleStyle.toLowerCase() !== 'text-centered' ? 
                <div className='content-module-description-container'>
                  { mainContent() }
                </div>
                : mainContent()
                }
                <hr className="intro-module-seperator" />
              </div>
            {/* </div> */}
            </div>
          </div>
        </Layout>
      ) : (
        <></>
      )}
    </>
  );
};

export default CpCmsLiteContentV3;
